import { axiosClient } from "@/lib/axiosClient";

export interface PublicGalleryImage {
    id: number;
    type: "image" | "embed";
    image_url: string | null;
    embed_url: string | null;
    display_order: number;
}

export interface PublicGalleryItem {
    id: number;
    title: string | null;
    album: string | null;
    description: string | null;
    image_url: string | null;
    display_order: number;
    images: PublicGalleryImage[];
    created_at: string;
}

export const getPublicGalleries = async (): Promise<PublicGalleryItem[]> => {
    const { data } = await axiosClient.get("/public/galleries");
    return data;
};
